import { useCallback, useMemo } from 'react';

import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import SimpleTableRow from '@/components/SimpleTable/SimpleTableRow';
import { SortDirectionEnum } from '@/models/gen/graphql';
import { useIssueHistory } from '@/features/IssueHistory';

const IssueHistoryTableColumns = (): JSX.Element => {
  return (
    <SimpleTableRow header>
      <SelectAllCell />
      <SortableCell name="STATION">Airport</SortableCell>
      <SortableCell name="DATETIME">Issue Time</SortableCell>
      <SortableCell name="CREATED_AT">Created</SortableCell>
      <SortableCell name="TRIP_SERVICER_IATA_AIRLINE_CODE">AL</SortableCell>
      <SortableCell name="TRIP_FLIGHT_NAME">FLT #</SortableCell>
      <SortableCell name="DRIVER_NAME">Employee</SortableCell>
      <SortableCell name="CAUSED_BY">Caused By</SortableCell>
      <SortableCell name="ROOT_CAUSE">Root Cause</SortableCell>
      <SortableCell name="TAXI_USED">Taxi?</SortableCell>
      <SortableCell name="TAXI_COST">Taxi Cost</SortableCell>
      <SortableCell name="RECOVERY_NEEDED">Recovery</SortableCell>
      <SortableCell name="FLIGHT_LATE">Plane Pushed?</SortableCell>
    </SimpleTableRow>
  );
};

const SelectAllCell = (): JSX.Element => {
  const [{ issues, selected }, setState] = useIssueHistory(({ issues, selected }) => ({ issues, selected }));

  const isSelectAll = useMemo((): boolean => {
    if (selected.size !== issues.size) return false;
    for (const id of selected.keys()) {
      if (!issues.has(id)) return false;
    }
    return true;
  }, [issues, selected]);

  const onClick = useCallback(
    (): void => setState((current) => ({ ...current, selected: isSelectAll ? new Map() : issues })),
    [issues, isSelectAll, setState]
  );

  return <SimpleTableCell.Select checked={isSelectAll} onChange={onClick} />;
};
const SortableCell = ({ name, children }: { name: string; children: React.ReactNode }): JSX.Element => {
  const [{ sortBy, sortDirection }, setState] = useIssueHistory(({ sortBy, sortDirection }) => ({ sortBy, sortDirection }));
  const onSort = (name: string, direction: SortDirectionEnum): void =>
    setState((current) => ({ ...current, sortBy: name, sortDirection: direction }));
  return (
    <SimpleTableCell.Sortable name={name} sortBy={sortBy} sortDirection={sortDirection} onSort={onSort}>
      {children}
    </SimpleTableCell.Sortable>
  );
};

export default IssueHistoryTableColumns;
